<template>
  <div class="flex flex-col bg-[#f8fafc] gap-4">
    <div class="bg-white rounded-xl shadow-sm border border-slate-200 border-t-4 border-t-[#0d4169] flex flex-col pt-3">
      <div class="relative z-30 px-6 pb-3 flex flex-col gap-4 border-b border-slate-100 bg-white">
        <h2 class="text-base font-bold text-[#0d4169] text-left m-0">HR</h2>
      </div>

      <div class="relative z-0 px-6 py-4">
        <OvertimePage
          api-base="/hr"
          privilege-name="HR Overtime Type"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import OvertimePage from '../../finance/advancedRegister/overtimePage.vue'
</script>
